module.exports = __webpack_public_path__ + "img/p6.7e621481.png";